import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
  selector: 'app-content',
  styleUrls: ['./content.component.scss'],
  templateUrl: './content.component.html',
  imports: [RouterOutlet],
})
export class ContentComponent {}
